import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import {Box, Typography, Stack, Link, Card} from '@mui/material/';
import React from 'react'
import CallOutlinedIcon from '@mui/icons-material/CallOutlined';
import MobileFriendlyOutlinedIcon from '@mui/icons-material/MobileFriendlyOutlined';
import FaxOutlinedIcon from '@mui/icons-material/FaxOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';
import YouTubeIcon from '@mui/icons-material/YouTube';
import NoteIcon from '@mui/icons-material/Note';
const RightTitleBox = () => {
  return (
  
    <Box sx={{
        
        border:'0px solid #001158',
        width:'400px',
        height:'580px',
        padding: '30px 10px 10px 15px',
        backgroundColor: '#00007F',
        borderRadius:'1%'
    }}>
        <NoteIcon color="primary"/>
        <Typography variant="h8" ml="5px" mt="20px" mr="5px" sx={{
        color:'white',
       }}>Please provide 9 digits Student's ID number, Date of Birth & Email Address.</Typography>
       <br/>
        <NoteIcon color="primary"/>
        <Typography variant="h8" ml="5px" mt="20px" mr="5px" sx={{
        color:'white',
       }}>The verification result will be sent to your given email address.</Typography>
       <br/><br/>
       <NoteIcon color="primary"/>
        <Typography variant="h8" ml="5px" mt="20px" mr="5px" sx={{
        color:'white',
       }}>For further query please contact us on:</Typography>
       <br/>
       <Card sx={{padding:'10px 0px 0px 10px', marginTop:'10px', marginBottom:'10px'}}>
            <HomeOutlinedIcon color="primary" /> 
            <Typography variant="h8" ml="5px" mt="20px" mr="5px" sx={{
                color:'black',
            }}>Bateshwar, Sylhet-3104, Bangladesh</Typography>
            <br/><br/>
            <CallOutlinedIcon color="primary"/>
            <Typography variant="h8" ml="5px" mt="20px" mr="5px" sx={{
                color:'black',
            }}> Phone: +88 02996642907-09 </Typography>
            <br/> 
            <MobileFriendlyOutlinedIcon color="primary"/>
            <Typography variant="h8" ml="5px" mt="20px" mr="5px" sx={{
                color:'black',
            }}> Mobile: +88 01313 050044</Typography>
            <MobileFriendlyOutlinedIcon color="primary"/>
            <Typography variant="h8" ml="5px" mt="20px" mr="5px" sx={{
                color:'black',
            }}> Mobile: +88 01313 050066 </Typography> 
            <br/>
            <FaxOutlinedIcon color="primary"/>
            <Typography variant="h8" ml="5px" mt="20px" mr="5px" sx={{
                color:'black',
            }}> Fax: +88 02996642910 </Typography> 
            <br/><br/>
            <EmailOutlinedIcon color="primary"/>
            <Typography variant="h8" ml="5px" mt="20px" mr="5px" sx={{
                color:'black',
            }}> Email: info@metrouni.edu.bd </Typography> 
            <br/>
            <LanguageOutlinedIcon color="primary"/>
            <Typography variant="h8" ml="5px" mt="20px" mr="5px" sx={{
                color:'black',
            }}> 
            <Link href="http://www.metrouni.edu.bd" 
                                style={{color:'black'}}>
            Web: www.metrouni.edu.bd </Link></Typography> 
            <br/><br/>
        </Card>
                
            
        
        <Typography variant="h8" ml="5px" mt="20px" mr="0px" sx={{
                color:'white', paddingLeft:'82px'
            }}>Follow us on
       <Link href="https://web.facebook.com/metropolitanuniversity/?_rdc=1&_rdr" 
                        style={{color:'white'}}>
       <FacebookOutlinedIcon color="primary" fontSize='large'/>   </Link>
       <Link href="https://www.youtube.com/MetropolitanUniversityBangladesh" 
                        style={{color:'white'}}>
        <YouTubeIcon color="primary" fontSize='large' />
        </Link> 
        </Typography>
    </Box>   
    
  )
}

export default RightTitleBox